"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const hasStatusCode = error => !!error.statusCode;
const getStatusCode = error => !!error && hasStatusCode(error) ? error.statusCode : undefined;
exports.default = getStatusCode;